//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['page', 'totalCount'],
  data() {
    return {
      current_page: 1, // 当前页
      pages: 1, // 总页数
      changePage: '', // 跳转页
      nowIndex: 0,
      routerTo: null,
    };
  },
  computed: {
    show() {
      return this.pages && this.pages !== 1;
    },
    pstart() {
      return this.current_page === 1;
    },
    pend() {
      return this.current_page === this.pages;
    },
    efont() {
      if (this.pages <= 7) return false;
      return this.current_page > 5;
    },
    ebehind() {
      if (this.pages <= 7) return false;
      const nowAy = this.indexs;
      return nowAy[nowAy.length - 1] !== this.pages;
    },
    indexs() {
      let left = 1;
      let right = this.pages;
      const ar = [];
      if (this.pages >= 7) {
        if (this.current_page > 5 && this.current_page < this.pages - 4) {
          left = Number(this.current_page) - 3;
          right = Number(this.current_page) + 3;
        } else {
          if (this.current_page <= 5) {
            left = 1;
            right = 7;
          } else {
            right = this.pages;

            left = this.pages - 6;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    },
  },
  created() {
    if (this.$route.name === 'news-page-id') {
      this.routerTo = '/news/page/';
    } else if (this.$route.name === 'column-page-id') {
      this.routerTo = '/column/page/';
    }
    this.current_page = this.$route.params.id;
    this.pages = Math.ceil(this.totalCount / 15);
  },
  methods: {
    pre() {
      this.$router.push(this.routerTo + this.current_page--);
    },
    next() {
      this.$router.push(this.routerTo + this.current_page++);
    },
    jumpPage(id) {
      this.current_page = id;
      this.$router.push(this.routerTo + id);
    },
  },
};
